import { TimeZone } from '../types/ViewModel/TimeZone';
import { TimeZoneBM } from '../types/BusinessModel/TimeZoneBM';

import { TimeZoneData } from '../types/ViewModel/TimeZoneData';
import { TimeZoneDataBM } from '../types/BusinessModel/TimeZoneDataBM';

export class TimeZoneFactory {
    constructor() {}

    private newTimeZone(timeZone: TimeZoneBM): TimeZone {
        const dstStartLocalTime = timeZone.dstStartLocalTime ? new Date(timeZone.dstStartLocalTime) : null;
        const dstEndLocalTime = timeZone.dstEndLocalTime ? new Date(timeZone.dstEndLocalTime) : null;
        return new TimeZone(
            timeZone.timeZoneId,
            timeZone.timeZoneCode,
            timeZone.year,
            dstStartLocalTime,
            dstEndLocalTime,
            timeZone.utcOffset,
            timeZone.utcOffsetDst
        );
    }

    public newTimeZoneArray(timeZoneList: TimeZoneBM[]): TimeZone[] {
        const TimeZoneArray: TimeZone[] = [];
        if (timeZoneList && timeZoneList.length > 0) {
            timeZoneList.map((t) => {
                const timeZone = this.newTimeZone(t);
                TimeZoneArray.push(timeZone);
            });
        }
        return TimeZoneArray;
    }

    public newTimeZoneArrayFromCode(timeZoneList: TimeZone[]): TimeZone[] {
        const TimeZoneArray: TimeZone[] = [];
        if (timeZoneList && timeZoneList.length > 0) {
            timeZoneList.map((t) => {
                const timeZone = new TimeZone(
                    t.timeZoneId,
                    t.timeZoneCode,
                    t.year,
                    t.dstStartLocalTime,
                    t.dstEndLocalTime,
                    t.utcOffset,
                    t.utcOffsetDst
                );
                TimeZoneArray.push(timeZone);
            });
        }
        return TimeZoneArray;
    }

    public newTimeZoneData(timeZoneDataBM: TimeZoneDataBM): TimeZoneData {
        const timeZoneData: TimeZoneData = {};

        Object.keys(timeZoneDataBM).forEach((portIdStr) => {
            const portId = parseInt(portIdStr, 10);
            const timeZoneBMArray = timeZoneDataBM[portId];
            timeZoneData[portId] = this.newTimeZoneArray(timeZoneBMArray);
        });

        return timeZoneData;
    }
}
